import User from 'models/core/user/Model.User';
import Model from 'models/Model';
import Claim from '../claim/Model.Claim';
import claimOwnershipLogListApi from './list/Api.ClaimOwnershipLog.List';

export default class ClaimOwnershipLog
  extends Model<Model.IClaimOwnershipLog>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IClaimOwnershipLog>
{
  id: number;
  claimId: number;
  claim?: Claim;
  ownerId?: number;
  owner?: Model.IUser;
  createdAtUtc: string;
  createdById?: number;
  createdBy?: Model.IUser;

  constructor(
    data: Partial<Model.IClaimStatusAuditLog> | Utils.FormData<Model.IClaimStatusAuditLog>,
    language?: Locale.Languages
  ) {
    super(
      {
        owner: User,
        createdBy: User,
        claim: Claim,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.owner?.fullName,
      info: this?.owner?.email,
      subtitle: this.claim?.displayInfo?.title,
    };
  }

  static async list(body?: Api.Core.ClaimOwnershipLog.List.IRequest) {
    const { payload, ...rest } = await claimOwnershipLogListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ClaimOwnershipLog(it)),
        count: payload.count,
      },
    };
  }
}
